import { render, staticRenderFns } from "./CallRecordQuery.vue?vue&type=template&id=588d1e55&scoped=true&"
import script from "./CallRecordQuery.vue?vue&type=script&lang=ts&"
export * from "./CallRecordQuery.vue?vue&type=script&lang=ts&"
import style0 from "./CallRecordQuery.vue?vue&type=style&index=0&id=588d1e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d1e55",
  null
  
)

export default component.exports